export default "__VITE_ASSET__bzi2HO3m__"